/** CheckboxPill — outlined card with embedded shadcn Checkbox.
 *  Used by Restraint flags (Curtains / Gates). */
import { Checkbox } from "@/components/ui/checkbox";

export default function CheckboxPill({ field, value, set }) {
  return (
    <label className="flex items-center gap-2 rounded-md border bg-white px-3 py-2 text-sm">
      <Checkbox
        checked={!!value}
        onCheckedChange={(v) => set(field.key, !!v)}
        data-testid={field.testid}
      />
      {field.label}
    </label>
  );
}
